import { Component } from '@angular/core';

@Component({
  selector: 'app-wallet-visible',
  templateUrl: './wallet-visible.component.html',
  styleUrls: ['./wallet-visible.component.scss']
})
export class WalletVisibleComponent {

}
